import { Box } from '@chakra-ui/react';
import { Editor } from '@tinymce/tinymce-react';
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import API_URL from '../../../utils/getAPIUrl';
import './tinymce_custom.css';

const TINYMCE_API = process.env.REACT_APP_TINYMCE_KEY;
const CustomEditor = ({ val, onChange, height = '200px' }) => {
  const editorRef = useRef(null);
  const { userToken } = useSelector(state => state.user);
  useEffect(() => {
    if (editorRef.current) {
      editorRef.current.setContent(val || '');
      editorRef.current.undoManager.clear();
    }
  }, [val, editorRef]);
  const imageUploadHandler = (blobInfo, progress) =>
    new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.withCredentials = false;
      xhr.open('POST', `${API_URL}/journal_images`);
      xhr.setRequestHeader('Authorization', userToken);

      xhr.upload.onprogress = e => {
        progress((e.loaded / e.total) * 100);
      };

      xhr.onload = () => {
        if (xhr.status === 403) {
          reject({ message: 'HTTP Error: ' + xhr.status, remove: true });
          return;
        }

        if (xhr.status < 200 || xhr.status >= 300) {
          reject('HTTP Error: ' + xhr.status);
          return;
        }

        const json = JSON.parse(xhr.responseText);

        if (!json || typeof json.location != 'string') {
          reject('Invalid JSON: ' + xhr.responseText);
          return;
        }

        resolve(json.location);
      };

      xhr.onerror = () => {
        reject(
          'Image upload failed due to a XHR Transport error. Code: ' +
            xhr.status
        );
      };

      const formData = new FormData();
      formData.append(
        'journal_image[image_data]',
        blobInfo.blob(),
        blobInfo.filename()
      );

      xhr.send(formData);
    });

  return (
    <Box
      w={'full'}
      border={'1px solid'}
      borderColor={'lightGray.500'}
      borderRadius={'6'}
    >
      <Editor
        apiKey={TINYMCE_API}
        onInit={(evt, editor) => {
          editorRef.current = editor;
          editorRef.current.setContent(val);
          editorRef.current.undoManager.clear();
        }}
        initialValue={val}
        onEditorChange={(value, editor) => {
          onChange(value);
        }}
        init={{
          height: height,
          menubar: false,
          branding: false,
          plugins: [
            'advlist',
            'autolink',
            'lists',
            'link',
            'image',
            'charmap',
            'preview',
            'anchor',
            'searchreplace',
            'visualblocks',
            'code',
            'fullscreen',
            'insertdatetime',
            'media',
            'table',
            'help',
            'wordcount',
            'quickbars',
          ],
          toolbar:
            'undo redo | blocks | ' +
            'bold italic forecolor | alignleft aligncenter ' +
            'alignright alignjustify | bullist numlist outdent indent | ' +
            'removeformat | link image ',
          image_title: true,
          quickbars_image_toolbar:
            'alignleft aligncenter alignright | rotateleft rotateright | imageoptions',
          automatic_uploads: true,
          images_upload_handler: imageUploadHandler,
          content_style:
            'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
          toolbar_mode: 'scrolling',
        }}
      />
    </Box>
  );
};

export default CustomEditor;
